export const CLEARTRIP_COUNTRIES = {
    title: 'Countries',
    countries: [
        {
            name_en: 'The United Arab Emirates',
            name_ar: 'الإمارات العربية المتحدة',
            href: 'https://www.cleartrip.ae'
        },
        {
            name_en: 'Kingdom of Saudi Arabia',
            name_ar: 'المملكة العربية السعودية',
            href: 'https://www.cleartrip.sa'
        },
        {
            name_en: 'Bahrain',
            name_ar: 'البحرين',
            href: 'https://www.cleartrip.bh'
        },
        {
            name_en: 'Kuwait',
            name_ar: 'الكويت',
            href: 'https://www.cleartrip.com.kw'
        },
        {
            name_en: 'Qatar',
            name_ar: 'قطر',
            href: 'https://www.cleartrip.qa'
        },
        {
            name_en: 'Sultanate of Oman',
            name_ar: 'سلطنة عمان',
            href: 'https://www.cleartrip.om'
        }
    ]
}

export const FLYIN_COUNTRIES = {
    title: 'Countries',
    countries: [
        {
            name_en: 'Saudi Arabia',
            name_ar: 'المملكة العربية السعودية',
            href: 'https://www.flyin.com'
        },
        {
            name_en: 'Egypt',
            name_ar: 'مصر',
            href: 'https://eg.flyin.com'
        },
        {
            name_en: 'The United Arab Emirates',
            name_ar: 'الإمارات العربية المتحدة',
            href: 'https://ae.flyin.com'
        }
    ]
}


export const COUNTRIES_BY_BRAND = {
    cleartrip: CLEARTRIP_COUNTRIES,
    flyin : FLYIN_COUNTRIES
}

export default COUNTRIES_BY_BRAND;

